import OperationalReportPage from './OperationalReportPage';
export default function SlowMovingReportPage(){return <OperationalReportPage kind="slow-moving"/>;}
